import React, { useState } from 'react';
import { FaTwitter, FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import allPaths from "../../Config/paths"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import SubscriptionForm from './SubscriptionForm';
import HeaderComponent from '../HeaderComponent/HeaderComponent';

const MainFooter = (props) => {
    const { selectedLanguage } = props
    const history = useHistory()
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

    return (
        <div>
            <div>
                <HeaderComponent title={selectedLanguage?.footer_txt_subscription} lineClass='bg-gray' titleClass='color-blue' />
                <SubscriptionForm {...props} />
            </div>
            <div className='fifth-design-footer'>
                <div className='fifth-des-footer-main'>
                    <p>
                        {selectedLanguage?.footer_txt_copy_right} {currentYear} | {selectedLanguage?.txt_all_rights_reserved}
                    </p>
                    <ul className='fifth-des-footer-ul'>
                        <li>
                            <a href="" onClick={() => history?.push(allPaths?.FIFHTTESTIMONIALS)}>
                                {selectedLanguage?.txt_testimonials}
                            </a>
                        </li>
                        <span>|</span>
                        <li>
                            <a href="">
                                {selectedLanguage?.txt_second_opinion}
                            </a>
                        </li>
                        <span>|</span>
                        <li>
                            <a href="" onClick={() => history?.push(allPaths?.FIFHTLATESTNEWS)}>
                                {selectedLanguage?.txt_news}
                            </a>
                        </li>
                        <span>|</span>
                        <li>
                            <a href="" onClick={() => history?.push(allPaths?.FIFHTCONTACT)}>
                                {selectedLanguage?.txt_contact_}
                            </a>
                        </li>
                        <span>|</span>
                        <li>
                            <a href="">
                                {selectedLanguage?.txt_sitemap}
                            </a>
                        </li>
                    </ul>
                    <div>
                        <button><FaFacebookF /></button>
                        <button><FaTwitter /></button>
                        <button><FaInstagram /></button>
                        <button><FaYoutube /></button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MainFooter